<ng-container>
  <div class="row mt-4 align-items-center">
    <div
      class="col- mt-4"
      style="margin-top: -3em !important"
      *ngIf="vistaBackoffice"
    >
      <a
        class="cursor-pointer"
        (click)="validarVolver()"
        data-toggle="tooltip"
        data-placement="top"
        title="VOLVER"
        alt="VOLVER"
      >
        <i class="bi bi-chevron-left mr-2"></i>
        Volver
      </a>
    </div>
    <div class="col-10" [ngClass]="!vistaBackoffice ? 'col-12' : ''">
      <h1 class="ocultar-mobile mt-2">Asignaturas del periodo</h1>
    </div>
  </div>
</ng-container>

<div class="row mt-5 align-items-center py-3 fondo_gris ocultar-mobile">
  <div class="col-0 ml-5">
    <div class="cuadrado-amarillo m-0"></div>
  </div>
  <div class="col-5">
    <p class="mb-0">
      Docente: &nbsp; <strong>{{ nombreDocente }}</strong>
    </p>
  </div>
  <div class="col-0 ml-4">
    <div class="cuadrado-amarillo m-0"></div>
  </div>
  <div class="col-5">
    <p class="mb-0">
      ID Docente (SAP): &nbsp; <strong>{{ idDocente }}</strong>
    </p>
  </div>
</div>

<div class="row mt-5 ocultar-mobile">
  <div class="col-2">
    <label class="titulo_criterios" for="exampleFormControlSelect2">Año</label
    ><label class="titulo_criterios-obligatorio ml-2" for="exampleFormControlSelect2">(obligatorio)</label>
    <select
      [disabled]="filtrosCargados.hasOwnProperty('dataDocente')"
      class="form-control select_criterios"
      [(ngModel)]="filtroAnyo"
      (ngModelChange)="obtenerPeriodos(filtroAnyo)"
      [ngClass]="{ 'is-invalid': submitted && tieneErrores['anyo'] }"
    >
      <option [value]="0">Seleccionar</option>
      <option *ngFor="let anyo of listaAnyo" [value]="anyo">{{ anyo }}</option>
    </select>
    <div *ngIf="submitted && tieneErrores['anyo']" class="invalid-feedback">
      <div *ngIf="tieneErrores['anyo']">Campo requerido</div>
    </div>
  </div>
  <div class="col-2">
    <label class="titulo_criterios" for="exampleFormControlSelect2"
      >Periodo</label
    ><label class="titulo_criterios-obligatorio ml-2" for="exampleFormControlSelect2">(obligatorio)</label>
    <select
      [disabled]="filtrosCargados.hasOwnProperty('dataDocente')"
      class="form-control select_criterios"
      [(ngModel)]="filtroPeriodo"
      (ngModelChange)="obtenerSedes(filtroAnyo, filtroPeriodo)"
      [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodo'] }"
    >
      <option [value]="0">Seleccionar</option>
      <option
        *ngFor="let periodo of listaPeriodo"
        [value]="periodo.periodoAcademicoId"
      >
        {{ periodo.periodoDescripcion }}
      </option>
    </select>
    <div *ngIf="submitted && tieneErrores['periodo']" class="invalid-feedback">
      <div *ngIf="tieneErrores['periodo']">Campo requerido</div>
    </div>
  </div>
  <div class="col-3">
    <label class="titulo_criterios" for="exampleFormControlSelect2"
      >Sedes</label
    >
    <select
      [disabled]="filtrosCargados.hasOwnProperty('dataDocente')"
      class="form-control select_criterios"
      [(ngModel)]="filtroSede"
    >
      <option [value]="0">Seleccionar</option>
      <option *ngFor="let sede of listaSede" [value]="sede.sedeId">
        {{ sede.descripcion }}
      </option>
      <option *ngIf="listaSede.length === 0" value="0" disabled>
        No hay sedes para seleccionar
      </option>
    </select>
  </div>
  <div class="col-1 centrar_iconos_botones mt-4">
    <button
      [disabled]="filtrosCargados.hasOwnProperty('dataDocente')"
      [ngClass]="
        filtrosCargados.hasOwnProperty('dataDocente') ? 'disabled-button' : ''
      "
      class="boton-buscar"
      data-toggle="tooltip"
      data-placement="top"
      title="BUSCAR"
      alt="BUSCAR"
      (click)="busqueda()"
    >
      <i class="bi bi-search"></i>
    </button>
  </div>
  <div class="col-1 centrar_iconos_botones mt-4">
    <button
      id="btn-limpiar-filtros-portal-calificaciones"
      [disabled]="filtrosCargados.hasOwnProperty('dataDocente')"
      [ngClass]="
        filtrosCargados.hasOwnProperty('dataDocente') ? 'disabled-button' : ''
      "
      class="boton-secundario tamanio_iconos-boton"
      data-toggle="tooltip"
      data-placement="top"
      title="LIMPIAR"
      alt="LIMPIAR"
      (click)="limpiarFiltros('')"
    >
      <i class="bi bi-x"></i>
    </button>
  </div>
</div>
<div
  *ngIf="alertaExitosa !== ''"
  class="alert alert-success tipografía_alertas mt-4 mb-4"
  role="alert"
>
  <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>
  {{ alertaExitosa }}
</div>
<div
  *ngIf="guardadoExitoso !== ''"
  class="alert alert-success tipografía_alertas mt-4 mb-4"
  role="alert"
>
  <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>
  {{ guardadoExitoso }}
</div>
<div
  *ngIf="error"
  class="alert alert-danger tipografía_alertas mt-4 mb-4 ocultar-mobile"
  role="alert"
>
  <i class="bi bi bi-x-circle tamanio_iconos-boton mr-2"></i>
  {{ error }}
</div>

<table
  class="table table-striped my-5 ocultar-mobile"
  *ngIf="lista.length == 0"
  aria-describedby="tabla secciones"
>
  <thead class="header_tabla_portal">
    <tr>
      <th class="header-tabla">Sede</th>
      <th class="header-tabla">Sección</th>
      <th class="header-tabla">Asignatura</th>
      <th class="header-tabla" style="text-align: center">
        Nº<br />
        Alumnos
      </th>
      <th class="header-tabla">Estado</th>
      <th class="header-tabla" style="text-align: center">
        % <br />
        Avan.<br />
        Calif.
      </th>
      <th class="header-tabla" style="text-align: center">
        % <br />
        Avan.<br />
        Exam.
      </th>
      <th class="header-tabla" style="text-align: center">
        % <br />
        Alum.<br />
        Cerrados
      </th>
      <th class="header-tabla">Calificar</th>
      <th class="header-tabla">Ponderar</th>
      <th class="header-tabla tablaHover" style="text-align: center">
        <i class="bi bi-info-circle" id="icono-info"> </i>
        <div id="triangle" class="triangle triangle-header"></div>
        <div [id]="'cstm-popover'" class="cstm-popover cstm-popover-header">
          Esta nueva columna te permitirá visualizar<br />
          el estado de la sincronización con Blackboard,<br />
          respecto de cada sección.
        </div>
        <br />Alineación con
        <br />
        Blackboard
      </th>
      <th class="header-tabla">Descargar</th>
    </tr>
  </thead>

  <tbody>
    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td style="overflow: visible">No hay datos disponibles en la tabla</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
  </tbody>
</table>
<table
  class="table table-striped my-5 ocultar-mobile"
  *ngIf="tableRender && lista.length != 0"
  aria-describedby="tabla secciones"
>
  <thead class="header_tabla_portal">
    <tr>
      <th class="header-tabla pl-3">Sede</th>
      <th class="header-tabla">Sección</th>
      <th class="header-tabla">Asignatura</th>
      <th class="header-tabla" style="text-align: center">
        Nº<br />
        Alumnos
      </th>
      <th class="header-tabla">Estado</th>
      <th class="header-tabla" style="text-align: center">
        % <br />
        Avan.<br />
        Calif.
      </th>
      <th class="header-tabla" style="text-align: center">
        % <br />
        Avan.<br />
        Exam.
      </th>
      <th class="header-tabla" style="text-align: center">
        % <br />
        Alum.<br />
        Cerrados
      </th>
      <th class="header-tabla">Calificar</th>
      <th class="header-tabla">Ponderar</th>
      <th class="header-tabla tablaHover" style="text-align: center">
        <i class="bi bi-info-circle" id="icono-info"> </i>
        <div id="triangle" class="triangle triangle-header"></div>
        <div [id]="'cstm-popover'" class="cstm-popover cstm-popover-header">
          Esta nueva columna te permitirá visualizar<br />
          el estado de la sincronización con Blackboard,<br />
          respecto de cada sección.
        </div>
        <br />Alineación con
        <br />
        Blackboard
      </th>
      <th class="header-tabla">Descargar</th>
    </tr>
  </thead>
  <tbody>
    <!-- Filtro por id seccion desde backoffice -->
    <ng-container *ngIf="filtrosCargados.hasOwnProperty('seccionId')">
      <tr *ngFor="let seccion of lista">
        <ng-container
          *ngIf="
            filtrosCargados?.seccionId != 0 &&
            filtrosCargados?.seccionId == seccion.idSeccion
          "
        >
          <td>{{ seccion.sede }}</td>
          <td>{{ seccion.seccion }}</td>
          <td>{{ seccion.asignatura }}</td>
          <td class="text-center">{{ seccion.cantidadAlumnos }}</td>
          <td>{{ seccion.estado }}</td>
          <td class="text-center">{{ seccion.porcAvCalificacion }}</td>
          <td class="text-center">{{ seccion.porcAvExamen }}</td>
          <td class="text-center">{{ seccion.porcAlumCerrados }}</td>
          <td>
            <p
              *ngIf="seccion.estado !== 'EN PROCESO'"
              class="cursor-pointer"
              (click)="navToSeccion(seccion, 'calificar')"
            >
              <i
                class="bi tamanio_iconos-boton d-flex justify-content-center color_iconos-tablas"
                [ngClass]="{
                  'bi-pencil': validarBtn(
                    'calificar',
                    seccion.calificar,
                    seccion.ponderar,
                    seccion.estado
                  ),
                  'bi-eye': !validarBtn(
                    'calificar',
                    seccion.calificar,
                    seccion.ponderar,
                    seccion.estado
                  ),
                  'bi-dash': seccion.estado === 'EN PROCESO'
                }"
              ></i>
            </p>
            <p
              *ngIf="seccion.estado === 'EN PROCESO'"
              class="cursor-pointer"
              (click)="navToSeccion(seccion, 'calificar')"
            >
              <i
                class="bi tamanio_iconos-boton d-flex justify-content-center color_iconos-tablas"
                [ngClass]="{ 'bi-dash': seccion.estado === 'EN PROCESO' }"
              ></i>
            </p>
          </td>
          <td>
            <p
              id="btn-ponderar-portal-calificaciones"
              *ngIf="seccion.estado !== 'EN PROCESO'"
              class="cursor-pointer"
              (click)="navToSeccion(seccion, 'ponderar')"
            >
              <i
                class="bi tamanio_iconos-boton d-flex justify-content-center color_iconos-tablas"
                [ngClass]="{
                  'bi-gear': validarBtn(
                    'ponderar',
                    seccion.calificar,
                    seccion.ponderar,
                    seccion.estado
                  ),
                  'bi-eye': !validarBtn(
                    'ponderar',
                    seccion.calificar,
                    seccion.ponderar,
                    seccion.estado
                  ),
                  'bi-dash': seccion.estado === 'EN PROCESO'
                }"
              ></i>
            </p>
            <p
              id="btn-ponderar-en-proceso-portal-calificaciones"
              *ngIf="seccion.estado === 'EN PROCESO'"
              class="cursor-pointer"
              (click)="navToSeccion(seccion, 'ponderar')"
            >
              <i
                class="bi tamanio_iconos-boton d-flex justify-content-center color_iconos-tablas"
                [ngClass]="{ 'bi-dash': seccion.estado === 'EN PROCESO' }"
              ></i>
            </p>
          </td>
          <td class="campo-blackboard">
            <p
              class="cursor-pointer btn-blackboard"
              [id]="'icono-blackboard-' + seccion.idSeccion"
              (mouseenter)="showPopupBlackboard(seccion.idSeccion)"
              (mouseleave)="hidePopupBlackboard(seccion.idSeccion)"
              *ngIf="seccion.descEstadoAlineacion === 'Habilitada'  && seccion.estado !== 'EN PROCESO'"
              (click)="navToAlineacion(seccion)"
            >
              Habilitada
            </p>
  
            <p
              class="cursor-pointer btn-blackboard"
              (mouseenter)="showPopupBlackboard(seccion.idSeccion)"
              (mouseleave)="hidePopupBlackboard(seccion.idSeccion)"
              *ngIf="seccion.descEstadoAlineacion === 'Configurar' && seccion.estado !== 'EN PROCESO'"
              (click)="navToAlineacion(seccion)"
            >
              Configurar
            </p>
            <p
              class="cursor-pointer btn-blackboard"
              (mouseenter)="showPopupBlackboard(seccion.idSeccion)"
              (mouseleave)="hidePopupBlackboard(seccion.idSeccion)"
              *ngIf="seccion.descEstadoAlineacion === 'Validar' && seccion.estado !== 'EN PROCESO'"
              (click)="navToAlineacion(seccion)"
            >
              Validar
            </p>
            <p
              class="cursor-pointer"
              *ngIf="
                !seccion.descEstadoAlineacion || seccion.estado === 'EN PROCESO'
              "
            >
              <i
                class="bi tamanio_iconos-boton d-flex justify-content-center color_iconos-tablas bi-dash"
              ></i>
            </p>
            <div
              [id]="'triangle-' + seccion.idSeccion"
              class="triangle triangle-content"
            ></div>
            <div
              [id]="'cstm-popover-' + seccion.idSeccion"
              class="cstm-popover cstm-popover-content"
              *ngIf="seccion.descEstadoAlineacion === 'Habilitada'  && seccion.estado !== 'EN PROCESO'"
            >
              Alineación creada, que permite<br />
              obtener o editar calificaciones<br />
              desde Blackboard.
            </div>
            <div
              [id]="'cstm-popover-' + seccion.idSeccion"
              class="cstm-popover cstm-popover-content cstm-popover-content-configurar"
              *ngIf="seccion.descEstadoAlineacion === 'Configurar' && seccion.estado !== 'EN PROCESO'"
            >
              Cree una alineación desde cero.
            </div>
            <div
              [id]="'cstm-popover-' + seccion.idSeccion"
              class="cstm-popover cstm-popover-content cstm-popover-content-validar"
              *ngIf="seccion.descEstadoAlineacion === 'Validar' && seccion.estado !== 'EN PROCESO'"
            >
              Acepte o edite una alineación<br />
              creada por asignatura.
            </div>
          </td>
          <td>
            <p
              class="cursor-pointer"
              (click)="
                descargarActa(
                  seccion.idSeccion,
                  filtroAnyo,
                  filtroPeriodo,
                  seccion.estado
                )
              "
            >
              <i
                class="bi tamanio_iconos-boton d-flex justify-content-center color_iconos-tablas"
                [ngClass]="{
                  'bi-dash': seccion.estado !== 'CERRADA' && !seccion.acta,
                  'bi-filetype-pdf':
                    seccion.estado === 'CERRADA' && seccion.acta
                }"
              ></i>
            </p>
          </td>
        </ng-container>
      </tr>
    </ng-container>
    <!-- Fin filtro por id seccion desde backoffice -->

    <ng-container
      *ngIf="
        !filtrosCargados.hasOwnProperty('seccionId') ||
        filtrosCargados?.seccionId == 0
      "
    >
      <tr *ngFor="let seccion of lista">
        <td>{{ seccion.sede }}</td>
        <td>{{ seccion.seccion }}</td>
        <td>{{ seccion.asignatura }}</td>
        <td class="text-center">{{ seccion.cantidadAlumnos }}</td>
        <td>{{ seccion.estado }}</td>
        <td class="text-center">{{ seccion.porcAvCalificacion }}</td>
        <td class="text-center">{{ seccion.porcAvExamen }}</td>
        <td class="text-center">{{ seccion.porcAlumCerrados }}</td>
        <td>
          <p
            *ngIf="seccion.estado !== 'EN PROCESO'"
            class="cursor-pointer"
            (click)="navToSeccion(seccion, 'calificar')"
          >
            <i
              class="bi tamanio_iconos-boton d-flex justify-content-center color_iconos-tablas"
              [ngClass]="{
                'bi-pencil': validarBtn(
                  'calificar',
                  seccion.calificar,
                  seccion.ponderar,
                  seccion.estado
                ),
                'bi-eye': !validarBtn(
                  'calificar',
                  seccion.calificar,
                  seccion.ponderar,
                  seccion.estado
                ),
                'bi-dash': seccion.estado === 'EN PROCESO'
              }"
            ></i>
          </p>
          <p
            *ngIf="seccion.estado === 'EN PROCESO'"
            class="cursor-pointer"
            (click)="navToSeccion(seccion, 'calificar')"
          >
            <i
              class="bi tamanio_iconos-boton d-flex justify-content-center color_iconos-tablas"
              [ngClass]="{ 'bi-dash': seccion.estado === 'EN PROCESO' }"
            ></i>
          </p>
        </td>
        <td>
          <p
            *ngIf="seccion.estado !== 'EN PROCESO'"
            class="cursor-pointer"
            (click)="navToSeccion(seccion, 'ponderar')"
          >
            <i
              class="bi tamanio_iconos-boton d-flex justify-content-center color_iconos-tablas"
              [ngClass]="{
                'bi-gear': validarBtn(
                  'ponderar',
                  seccion.calificar,
                  seccion.ponderar,
                  seccion.estado
                ),
                'bi-eye': !validarBtn(
                  'ponderar',
                  seccion.calificar,
                  seccion.ponderar,
                  seccion.estado
                ),
                'bi-dash': seccion.estado === 'EN PROCESO'
              }"
            ></i>
          </p>
          <p
            *ngIf="seccion.estado === 'EN PROCESO'"
            class="cursor-pointer"
            (click)="navToSeccion(seccion, 'ponderar')"
          >
            <i
              class="bi tamanio_iconos-boton d-flex justify-content-center color_iconos-tablas"
              [ngClass]="{ 'bi-dash': seccion.estado === 'EN PROCESO' }"
            ></i>
          </p>
        </td>

        <td class="campo-blackboard">
          <p
            class="cursor-pointer btn-blackboard"
            [id]="'icono-blackboard-' + seccion.idSeccion"
            (mouseenter)="showPopupBlackboard(seccion.idSeccion)"
            (mouseleave)="hidePopupBlackboard(seccion.idSeccion)"
            *ngIf="seccion.descEstadoAlineacion === 'Habilitada'  && seccion.estado !== 'EN PROCESO'"
            (click)="navToAlineacion(seccion)"
          >
            Habilitada
          </p>

          <p
            class="cursor-pointer btn-blackboard"
            (mouseenter)="showPopupBlackboard(seccion.idSeccion)"
            (mouseleave)="hidePopupBlackboard(seccion.idSeccion)"
            *ngIf="seccion.descEstadoAlineacion === 'Configurar'  && seccion.estado !== 'EN PROCESO'"
            (click)="navToAlineacion(seccion)"
          >
            Configurar
          </p>
          <p
            class="cursor-pointer btn-blackboard"
            (mouseenter)="showPopupBlackboard(seccion.idSeccion)"
            (mouseleave)="hidePopupBlackboard(seccion.idSeccion)"
            *ngIf="seccion.descEstadoAlineacion === 'Validar' && seccion.estado !== 'EN PROCESO'"
            (click)="navToAlineacion(seccion)"
          >
            Validar
          </p>
          <p
            class="cursor-pointer"
            *ngIf="
              !seccion.descEstadoAlineacion || seccion.estado === 'EN PROCESO'
            "
          >
            <i
              class="bi tamanio_iconos-boton d-flex justify-content-center color_iconos-tablas bi-dash"
            ></i>
          </p>
          <div
            [id]="'triangle-' + seccion.idSeccion"
            class="triangle triangle-content"
          ></div>
          <div
            [id]="'cstm-popover-' + seccion.idSeccion"
            class="cstm-popover cstm-popover-content"
            *ngIf="seccion.descEstadoAlineacion === 'Habilitada' && seccion.estado !== 'EN PROCESO'"
          >
            Alineación creada, que permite<br />
            obtener o editar calificaciones<br />
            desde Blackboard.
          </div>
          <div
            [id]="'cstm-popover-' + seccion.idSeccion"
            class="cstm-popover cstm-popover-content cstm-popover-content-configurar"
            *ngIf="seccion.descEstadoAlineacion === 'Configurar' && seccion.estado !== 'EN PROCESO'"
          >
            Cree una alineación desde cero.
          </div>
          <div
            [id]="'cstm-popover-' + seccion.idSeccion"
            class="cstm-popover cstm-popover-content cstm-popover-content-validar"
            *ngIf="seccion.descEstadoAlineacion === 'Validar' && seccion.estado !== 'EN PROCESO'"
          >
            Acepte o edite una alineación<br />
            creada por asignatura.
          </div>
        </td>
        <td>
          <p
            class="cursor-pointer"
            (click)="
              descargarActa(
                seccion.idSeccion,
                filtroAnyo,
                filtroPeriodo,
                seccion.estado
              )
            "
          >
            <i
              class="bi tamanio_iconos-boton d-flex justify-content-center color_iconos-tablas"
              [ngClass]="{
                'bi-dash': seccion.estado !== 'CERRADA',
                'bi-filetype-pdf': seccion.estado === 'CERRADA' && seccion.acta
              }"
            ></i>
          </p>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>

<div class="row my-4 ml-2 align-items-center ocultar-mobile">
  <p class="mb-0 titulo_principal-menu">IMPORTANTE</p>

  <i
    class="bi tamanio_iconos-boton ml-3 mb-0"
    style="cursor: pointer"
    (click)="expandirNotificaciones = !expandirNotificaciones"
    [ngClass]="{
      'bi-plus-circle': !expandirNotificaciones,
      'bi-dash-circle': expandirNotificaciones
    }"
  ></i>
</div>
<div *ngIf="expandirNotificaciones">
  <div *ngFor="let notificacion of listaNotificacionesCurr; index as ind">
    <hr class="mb-0 mt-0 ocultar-mobile" />
    <div class="row align-items-center ocultar-mobile">
      <div class="col-0 ml-4">
        <div class="cuadrado-amarillo m-0"></div>
      </div>
      <div class="col-2">
        <p class="mb-0">
          <strong class="dia_fecha_importante">{{
            notificacion.fechaNumero
          }}</strong>
          {{ notificacion.fecha }}
        </p>
      </div>
      <div class="col">
        <p class="mb-0 py-3 pl-3 fondo_gris">{{ notificacion.mensaje }}</p>
      </div>
    </div>
    <hr
      class="mb-0 mt-0 ocultar-mobile"
      *ngIf="ind == listaNotificacionesCurr.length - 1"
    />
  </div>
</div>

<!-- ///////////////////////////////////////////////////////////// -->

<!-- MOBILE & TABLET -->
<h1 class="ocultar-desktop">Asignaturas del periodo</h1>

<!-- DATOS DOCENTE -->

<div class="py-2 mt-5 fondo_gris ocultar-desktop">
  <p class="mb-0 mt-2 ml-5">Docente:</p>
  <p class="mt-0 ml-5 mb-3 datos_docente">{{ nombreDocente }}</p>
  <p class="mb-0 ml-5">ID Docente (SAP):</p>
  <p class="mt-0 ml-5 datos_docente">{{ idDocente }}</p>
</div>
<!-- FIN DATOS DOCENTE -->
<div
  *ngIf="error"
  class="alert alert-danger tipografía_alertas mt-4 mb-4 ocultar-desktop"
  role="alert"
>
  <i class="bi bi bi-x-circle tamanio_iconos-boton mr-2"></i>
  {{ error }}
</div>
<!-- FILTROS -->
<div class="row align-items-center mt-5 mx-2 ocultar-desktop">
  <div class="col">
    <p>FILTROS</p>
  </div>
  <div class="col text-right">
    <button class="btn" (click)="expandirFiltros = !expandirFiltros">
      <i
        class="bi bi-plus-circle tamanio_iconos-boton ml-3"
        [ngClass]="{
          'bi-plus-circle': !expandirFiltros,
          'bi-dash-circle': expandirFiltros
        }"
      ></i>
    </button>
  </div>
</div>

<div class="row mx-2 ocultar-desktop" *ngIf="expandirFiltros">
  <div class="col-12">
    <label class="titulo_criterios" for="exampleFormControlSelect2">Año</label>
    <select
      class="form-control select_criterios"
      [(ngModel)]="filtroAnyo"
      (ngModelChange)="obtenerPeriodos(filtroAnyo)"
      [ngClass]="{ 'is-invalid': submitted && tieneErrores['anyo'] }"
      [disabled]="filtrosCargados.hasOwnProperty('dataDocente')"
    >
      <option [value]="0">Seleccionar</option>
      <option *ngFor="let anyo of listaAnyo" [value]="anyo">{{ anyo }}</option>
    </select>
    <div *ngIf="submitted && tieneErrores['anyo']" class="invalid-feedback">
      <div *ngIf="tieneErrores['anyo']">Campo requerido</div>
    </div>
  </div>
  <div class="col-12 mt-4">
    <label class="titulo_criterios" for="exampleFormControlSelect2"
      >Periodo</label
    >
    <select
      class="form-control select_criterios"
      [(ngModel)]="filtroPeriodo"
      (ngModelChange)="obtenerSedes(filtroAnyo, filtroPeriodo)"
      [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodo'] }"
      [disabled]="filtrosCargados.hasOwnProperty('dataDocente')"
    >
      <option [value]="0">Seleccionar</option>
      <option
        *ngFor="let periodo of listaPeriodo"
        [value]="periodo.periodoAcademicoId"
      >
        {{ periodo.periodoDescripcion }}
      </option>
    </select>
    <div *ngIf="submitted && tieneErrores['periodo']" class="invalid-feedback">
      <div *ngIf="tieneErrores['periodo']">Campo requerido</div>
    </div>
  </div>
  <div class="col-12 mt-4 mb-5">
    <label class="titulo_criterios" for="exampleFormControlSelect2">Sede</label>
    <select
      class="form-control select_criterios"
      [(ngModel)]="filtroSede"
      [disabled]="filtrosCargados.hasOwnProperty('dataDocente')"
    >
      <option [value]="0">Seleccionar</option>
      <option *ngFor="let sede of listaSede" [value]="sede.sedeId">
        {{ sede.descripcion }}
      </option>
      <option *ngIf="listaSede.length === 0" value="0" disabled>
        No hay sedes para seleccionar
      </option>
    </select>
  </div>
  <div class="col-12 d-flex justify-content-center mb-5 ocultar-desktop">
    <button
      class="boton-secundario boton-calificar mt-5 ocultar-desktop"
      [disabled]="filtrosCargados.hasOwnProperty('dataDocente')"
      [ngClass]="
        filtrosCargados.hasOwnProperty('dataDocente') ? 'disabled-button' : ''
      "
      title="BUSCAR"
      alt="BUSCAR"
      (click)="busqueda()"
    >
      BUSCAR
    </button>
  </div>
</div>

<!-- FIN FILTROS -->

<!-- DATOS SECCIONES -->
<ng-container
  *ngIf="
    !filtrosCargados.hasOwnProperty('seccionId') ||
    filtrosCargados?.seccionId == 0
  "
>
  <div *ngFor="let seccion of lista">
    <div class="mt-3 mx-4 borde_inferior_datos_secciones ocultar-desktop">
      <div class="row">
        <div class="col">
          <p>Sede</p>
        </div>
        <div class="col">
          <p class="text-right">
            <strong>{{ seccion.sede }}</strong>
          </p>
        </div>
      </div>
    </div>

    <div class="mt-3 mx-4 borde_inferior_datos_secciones ocultar-desktop">
      <div class="row">
        <div class="col">
          <p>Sección</p>
        </div>
        <div class="col">
          <p class="text-right">
            <strong>{{ seccion.seccion }}</strong>
          </p>
        </div>
      </div>
    </div>

    <div class="mt-3 mx-4 borde_inferior_datos_secciones ocultar-desktop">
      <div class="row">
        <div class="col">
          <p>Nº Alumnos</p>
        </div>
        <div class="col">
          <p class="text-right">
            <strong>{{ seccion.cantidadAlumnos }}</strong>
          </p>
        </div>
      </div>
    </div>

    <div class="mt-3 mx-4 borde_inferior_datos_secciones ocultar-desktop">
      <div class="row">
        <div class="col">
          <p>Asignatura</p>
        </div>
        <div class="col">
          <p class="text-right">
            <strong>{{ seccion.asignatura }}</strong>
          </p>
        </div>
      </div>
    </div>

    <div class="mt-3 mx-4 borde_inferior_datos_secciones ocultar-desktop">
      <div class="row">
        <div class="col">
          <p>Estado</p>
        </div>
        <div class="col">
          <p class="text-right">
            <strong>{{ seccion.estado }}</strong>
          </p>
        </div>
      </div>
    </div>

    <div
      class="mt-3 mx-4 borde_inferior_datos_secciones ocultar-desktop"
      *ngIf="seccion.estado === 'CERRADA'"
    >
      <div class="row">
        <div class="col">
          <p>Descargar</p>
        </div>
        <div class="col">
          <p
            class="cursor-pointer"
            (click)="
              descargarActa(
                seccion.idSeccion,
                filtroAnyo,
                filtroPeriodo,
                seccion.estado
              )
            "
          >
            <i
              class="bi tamanio_iconos-boton d-flex justify-content-end color_iconos-tablas"
              [ngClass]="{
                'bi-dash': seccion.estado !== 'CERRADA' && !seccion.acta,
                'bi-filetype-pdf': seccion.estado === 'CERRADA' && seccion.acta
              }"
            ></i>
          </p>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center mb-5 ocultar-desktop">
      <button
        (click)="navToSeccion(seccion, 'calificar')"
        class="boton-secundario boton-calificar mt-5 ocultar-desktop"
        data-toggle="tooltip"
        data-placement="top"
        title="SELECCIONAR"
        alt="SELECCIONAR"
      >
        calificar
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="filtrosCargados.hasOwnProperty('seccionId')">
  <div *ngFor="let seccion of lista">
    <ng-container
      *ngIf="
        filtrosCargados?.seccionId != 0 &&
        filtrosCargados?.seccionId == seccion.idSeccion
      "
    >
      <div class="mt-3 mx-4 borde_inferior_datos_secciones ocultar-desktop">
        <div class="row">
          <div class="col">
            <p>Sede</p>
          </div>
          <div class="col">
            <p class="text-right">
              <strong>{{ seccion.sede }}</strong>
            </p>
          </div>
        </div>
      </div>

      <div class="mt-3 mx-4 borde_inferior_datos_secciones ocultar-desktop">
        <div class="row">
          <div class="col">
            <p>Sección</p>
          </div>
          <div class="col">
            <p class="text-right">
              <strong>{{ seccion.seccion }}</strong>
            </p>
          </div>
        </div>
      </div>

      <div class="mt-3 mx-4 borde_inferior_datos_secciones ocultar-desktop">
        <div class="row">
          <div class="col">
            <p>Nº Alumnos</p>
          </div>
          <div class="col">
            <p class="text-right">
              <strong>{{ seccion.cantidadAlumnos }}</strong>
            </p>
          </div>
        </div>
      </div>

      <div class="mt-3 mx-4 borde_inferior_datos_secciones ocultar-desktop">
        <div class="row">
          <div class="col">
            <p>Asignatura</p>
          </div>
          <div class="col">
            <p class="text-right">
              <strong>{{ seccion.asignatura }}</strong>
            </p>
          </div>
        </div>
      </div>

      <div class="mt-3 mx-4 borde_inferior_datos_secciones ocultar-desktop">
        <div class="row">
          <div class="col">
            <p>Estado</p>
          </div>
          <div class="col">
            <p class="text-right">
              <strong>{{ seccion.estado }}</strong>
            </p>
          </div>
        </div>
      </div>

      <div
        class="mt-3 mx-4 borde_inferior_datos_secciones ocultar-desktop"
        *ngIf="seccion.estado === 'CERRADA'"
      >
        <div class="row">
          <div class="col">
            <p>Descargar</p>
          </div>
          <div class="col">
            <p
              class="cursor-pointer"
              (click)="
                descargarActa(
                  seccion.idSeccion,
                  filtroAnyo,
                  filtroPeriodo,
                  seccion.estado
                )
              "
            >
              <i
                class="bi tamanio_iconos-boton d-flex justify-content-end color_iconos-tablas"
                [ngClass]="{
                  'bi-dash': seccion.estado !== 'CERRADA' && !seccion.acta,
                  'bi-filetype-pdf':
                    seccion.estado === 'CERRADA' && seccion.acta
                }"
              ></i>
            </p>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center mb-5 ocultar-desktop">
        <button
          (click)="navToSeccion(seccion, 'calificar')"
          class="boton-secundario boton-calificar mt-5 ocultar-desktop"
          data-toggle="tooltip"
          data-placement="top"
          title="SELECCIONAR"
          alt="SELECCIONAR"
        >
          ingresar
        </button>
      </div>
    </ng-container>
  </div>
</ng-container>

<div
  class="text-center"
  *ngIf="
    submitted &&
    lista.length === 0 &&
    !filtrosCargados.hasOwnProperty('dataDocente')
  "
  style="font-size: 1.6rem"
>
  No hay datos disponibles
</div>
<!-- FIN DATOS SECCIONES -->

<app-modal-info
  modalId="modal-info"
  [titulo]="infoModalTitulo"
  [texto]="infoModalTexto"
></app-modal-info>
<button
  id="btn-modal-info"
  type="button"
  class="btn btn-primary d-none"
  data-toggle="modal"
  data-target="#modal-info"
>
  Modal info
</button>
